import React from 'react';
import { Button, LinkBox, LinkOverlay, Container, Box, SimpleGrid, Card, CardBody, Image, Icon, UnorderedList, ListItem, Text, Stack, Flex, Heading } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import ReactPlayer from 'react-player/youtube';
import { FaLinkedin, FaTwitter, FaYoutube, FaFacebook, FaInstagram } from 'react-icons/fa';


import Recos from '../../../components/sections/recos';

import SocialButton from '../../../components/sections/socialbutton';
import HeadingWithText from '../../../components/sections/headingwithtext';
import praVellumBag from '../../../components/ui/ourbrands/prAna_S21_Vellum-bag.jpg'
import praWhoWeAre1 from '../../../components/ui/ourbrands/pra_whoweare_1.jpg'
import praWhoWeAre2 from '../../../components/ui/ourbrands/pra_whoweare_2.jpg'
import praCheese from '../../../components/ui/ourbrands/pra_cheese.jpg'
import praConstruction from '../../../components/ui/ourbrands/pra_construction.jpg'
import praRockWall from '../../../components/ui/ourbrands/pra_rockwall.jpg'
import praSunglasses from '../../../components/ui/ourbrands/pra_sunglasses.jpg'

export default function PranaTabPanel() {
  return (
    <Box>
      <Container maxW='6xl' my={14} className='flow'>
        <HeadingWithText
          title={<Heading as='h1'>CLOTHING FOR POSITIVE CHANGE</Heading>}
          subTitle="From the farm to the factory to our closets, we believe you can help create positive change in our world through clothing. Here at prAna, we want to inspire you and others to start asking questions about your clothes in the same way you ask about the food you eat. Together we can fundamentally change the way clothing is made."
          justify="center"
          align="center"
          my={4}
          px={180}
        />
        <SimpleGrid columns={{ base: 1, md: 2 }} py={4} align="center">
          <Card variant="unstyled">
            <CardBody>
              <ReactPlayer url="https://www.youtube.com/embed/yaNg1-1b1lc?autoplay=0&rel=0&enablejsapi=1&wmode=opaque" />
            </CardBody>
          </Card>
          <Card variant="unstyled">
            <CardBody>
              <Image src={praVellumBag} borderRadius={10}/>
            </CardBody>
          </Card>
        </SimpleGrid>
        <HeadingWithText
          title="WHO WE ARE"
          subTitle={`We Are prAna.\n\n` +
            `We inspire you to chase adventure, stay active in your own unique way, and always look good doing it. We strive to responsibly outfit those journeys with respect for the planet and its people. We commit to education and exploration in the name of progress, so we can all create positive change.\n\n` +
            `Whether you’re commuting to work or wandering the globe, rest assured we’ve been there, and have used these moments to design our products with sustainability and style.`}
          align="center"
          justify="center"
          my={4}
          mx={180}
        />
        <Flex justifyContent={'center'}>
          <LinkBox as="a">
            <LinkOverlay href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/prAna_Careers" isExternal>
              <Button size="lg" px={6} bg="black" color="white" borderRadius={66}>View Jobs at prAna<Icon color="white" w={5} h={5} as={ExternalLinkIcon} pl="4px"/></Button>
            </LinkOverlay>
          </LinkBox>
        </Flex>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} py={4} align="center">
          <Card variant="unstyled">
            <CardBody>
              <Image src={praWhoWeAre1} borderRadius={10}/>
            </CardBody>
          </Card>
          <Card variant="unstyled">
            <CardBody>
              <Image src={praWhoWeAre2} borderRadius={10}/>
            </CardBody>
          </Card>
        </SimpleGrid>
        <HeadingWithText
          title="WHAT WE BELIEVE"
          subTitle="We believe our work has meaning and is connected to a higher purpose. prAna’s unique company culture is a top priority and each of us is responsible for nurturing it as we grow. Our core values guide us in all we do."
          align="center"
          justify="center"
          my={4}
          mx={180}
        />
        <UnorderedList>
          <ListItem>Positive Change: We take positive steps towards environmental and social change.</ListItem>
          <ListItem>Balance: We believe in a healthy, active and balanced life to have energy to live fully and be our best selves at work and at home for those who are important to us.</ListItem>
          <ListItem>SEVA: We seek out and seize opportunities to serve each other, our customers and community with no expectation of gratitude or anything else in return. We call this SEVA.</ListItem>
          <ListItem>Energy: We are high energy, hardworking and playful.</ListItem>
          <ListItem>Quality: We strive to deliver the highest quality product, customer and employee experience.</ListItem>
        </UnorderedList>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} py={4} align="center">
          <Card variant="unstyled">
            <CardBody>
              <Image src={praCheese} borderRadius={10}/>
            </CardBody>
          </Card>
          <Card variant="unstyled">
            <CardBody>
              <Image src={praConstruction} borderRadius={10}/>
            </CardBody>
          </Card>
        </SimpleGrid>
        <HeadingWithText
          title="WHY WORK AT prAna"
          align="center"
          justify="center"
          my={4}
          px={180}
        />
        <Text justify="left" whiteSpace="pre-line" my={4} px={180}>
          {`When you come to work at prAna it isn’t just a job, it is a fulfilling lifestyle we hold dear and value deeply. Our culture is a unique blend of high performance and casual – and your talent and energy can create positive change and directly impact our success.\n\n` +
            `prAna is located in beautiful Carlsbad (San Diego), CA. We are close to the beach, the mountains or the desert so you can enjoy outdoor activities year-round. Oh, and we allow dogs at work which is pretty cool, too.\n\n` +
            `“Our culture here at prAna is collaborative, inclusive and rewarding. This company is unlike any others I’ve ever experienced working for and it is something I’ve really loved about prAna.“ – prAna Retail\n\n` +
            `“I love working for a company that is both environmentally and socially responsible in the way we do business. It is a responsibility that extends outside of the workplace that will have lasting impact long after I am gone from the face of the earth. It is worthwhile and meaningful to be a part of that.” – prAna HQ\n\n` +
            `“prAna truly cares about both my professional and personal growth while also promoting self-care. Upper management understands that a working environment which allows for lunch times spent being active and a focus on mindfulness and service (SEVA) enables employees to consistently produce their best work. The people that work here feel more like a big group of friends than simply co-workers and that makes roaming the halls feel much more welcoming than any other office.” – prAna HQ\n\n` +
            `“I am always learning, growing and challenging myself and I can confidently say I am a better person now than who I was when I first started in the company 4 years ago and I love that I can say that.” – prAna Retail\n\n` +
            `“The number one thing for me has been the amazing prioritization of work-life balance. The encouragement to always take your lunch break, and to leave on time, has been such a 180 from jobs I’ve had in the past, where if you left on time you were side eyed and seen as not working hard enough. prAna genuinely and holistically cares about their employees’ time and you can feel it in your day to day.” – prAna HQ\n\n` +
            `“I am inspired by prAna’s commitment, and its people-driven culture, where we are valued & empowered.” – prAna Retail`}
        </Text>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} py={4} align="center">
          <Card variant="unstyled">
            <CardBody>
              <Image src={praRockWall} borderRadius={10}/>
            </CardBody>
          </Card>
          <Card variant="unstyled">
            <CardBody>
              <Image src={praSunglasses} borderRadius={10}/>
            </CardBody>
          </Card>
        </SimpleGrid>
        <Flex justifyContent={'center'}>
          <LinkBox as='a' py={4}>
            <LinkOverlay href="https://www.prana.com" isExternal>
              <Button bg="#333" color="white" size="lg" rightIcon={<ExternalLinkIcon />}>Visit prAna.com</Button>
            </LinkOverlay>
          </LinkBox>
        </Flex>
        <Recos siteId="bcpx-Prana_US" title="Our Best Sellers"/>
        <HeadingWithText title="FOLLOW prAna" />
        <Stack direction="row" spacing={6} justifyContent={'center'}>
          <SocialButton label="Facebook" href="https://www.facebook.com/prana/">
            <FaFacebook size="40px" />
          </SocialButton>
          <SocialButton label="Instagram" href="https://www.instagram.com/prana/?hl=en">
            <FaInstagram size="40px" />
          </SocialButton>
          <SocialButton label="Twitter" href="https://twitter.com/prAna?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor">
            <FaTwitter size="40px" />
          </SocialButton>
          <SocialButton label="YouTube" href="https://www.youtube.com/channel/UC5jccBbILz4YtOXgoD2APXg">
            <FaYoutube size="40px" />
          </SocialButton>
          <SocialButton label="LinkedIn" href="https://www.linkedin.com/company/prana-living/">
            <FaLinkedin size="40px" />
          </SocialButton>
        </Stack>
      </Container>
    </Box>
  )
}
